import React from 'react';

import { TableCell, TableRow } from '@mui/material';

type ModelCountRowProps = {
  label: string;
  count: number | undefined;
};
export default function ModelCountRow({ label, count }: ModelCountRowProps) {
  return (
    <TableRow>
      <TableCell>{label}</TableCell>
      <TableCell align="right">{count ?? '...'}</TableCell>
    </TableRow>
  );
}
